import { Box, Card, Typography } from '@mui/material'
import { ChartBox } from '@biolumina/ui/components/chartBox/chartBox'
import React from 'react'

export const ElementClinicalStudies = () => {
  return (
    <ChartBox
      display="flex"
      justifyContent="center"
      width="100%"
      bgcolor="white"
    >
      <Card
        sx={{
          width: '100%',

          borderRadius: 0,
          position: 'relative',
          boxShadow: 'none',
          margin: 0,
          padding: 0,
        }}
      >
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            height: 'auto',
          }}
        >
          <Box
            sx={{
              position: 'relative',
            }}
          >
            <Box
              alt=""
              sx={{
                width: '100%',
                backgroundImage: {
                  xs: 'url(/images/about-ibtrozi/studied-in-a-large-population-mobile.svg)',
                  md: 'url(/images/about-ibtrozi/studied-in-a-large-population-desktop.svg)',
                },
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                height: 'auto',
                aspectRatio: { xs: '247 / 149', md: '694 / 213' },
                display: 'block',
              }}
            />
          </Box>

          <Typography
            sx={{
              position: { xs: 'relative', md: 'absolute' },
              right: { xs: 'unset', md: 50 },
              top: { xs: 0, md: 40 },
              width: { xs: '90%', md: 257 },
              maxWidth: 257,
              margin: { xs: '0 auto', md: '0' },
              fontSize: { xs: 'clamp(20px, 7.9vw, 31px)', md: '31px' },
              color: '#b85967',
              lineHeight: '43px',
              letterSpacing: 0,
            }}
          >
            <Box
              component="span"
              sx={{
                fontWeight: 500,
                fontSize: 'inherit', // Inherits the clamped size
              }}
            >
              Studied in <nobr>a large</nobr>
            </Box>
            <Box component="span" fontSize={22} fontWeight={800}>
              {' '}
              <br />
            </Box>
            <Box
              component="span"
              sx={{
                fontSize: { xs: 'clamp(22px, 9vw, 35px)', md: '35px' },
                fontWeight: 900,
              }}
            >
              ROS1+ NSCLC
            </Box>
            <br />
            <Box
              component="span"
              sx={{
                fontSize: { xs: 'clamp(30px, 12vw, 47px)', md: '47px' },
                fontWeight: 900,
              }}
            >
              population
            </Box>
          </Typography>
        </Box>
      </Card>
    </ChartBox>
  )
}
